/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAffiliateGallery from 'sites/allas/components/standalone/AffiliateGallery';

export const DynamicStandaloneAffiliateGallery = StandaloneAffiliateGallery;
export type DynamicStandaloneAffiliateGalleryProps = PropsFromComponent<typeof StandaloneAffiliateGallery>;

export const DynamicStandaloneAffiliateGalleryWith = (extras: DynamicStandaloneExtras): typeof StandaloneAffiliateGallery => {
    return function DynamicStandaloneAffiliateGallery(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AffiliateGallery');
        return <StandaloneAffiliateGallery {...mergeProps({ options: { theme } }, props)} />;
    }
}